<template>
    <span>

        <template v-if="discount">
            <strong><span class="ml-1 text-secondary " >{{firstPrice(price, discount) | priceFormat }} </span> </strong>
        </template>
        <template v-if="customerOffer">
            <strong><span class=" ml-1 text-primary"> {{firstPrice(price, customerOffer )  | priceFormat }}  </span> </strong>
        </template>
    </span>
</template>

<script>
    import Product from '@/assets/product'

    export default {
        name: "Price",
        props: {
            discount: Number,
            customerOffer: Number,
            price: Number,
        },
        methods: {
            firstPrice(price, discount) {
                return Product.discountedPrice(price, discount, 3)
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Price.vue